<footer>
    <div>
        <div class="row">
            <div class="col-2">
                <img src="/newpion/static/pionfront/assets/img/logo_footer.png">
            </div>
            <div class="col-9">
                <ul class="top_menu white">
                    <li><a href="">Главная</a></li>
                    <!-- <li><a href="">Руководство пользователя</a></li>
                    <li><a href="">Обзор сервиса</a></li>
                    <li><a href="">ДЕМО</a></li>
                    <li><a href="">О нас</a></li> -->
                </ul>
            </div>
            <div class="col-1 arrow_totop">
                <img onclick="window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });" src="/newpion/static/pionfront/assets/img/arrow_totop.png">
            </div>
        </div>

        <div class="row">
            <div class="col-5 logo_footer">
                <img src="/newpion/static/pionfront/assets/img/footer_logo1.png">
                <img src="/newpion/static/pionfront/assets/img/footer_logo2.png">
                <img src="/newpion/static/pionfront/assets/img/footer_logo3.png">
            </div>
            <div class="col-6 polit">
                <p>
                    <!-- <a href="">Пользовательское соглашение</a>
                    <a href="">Политика конфиденциальности</a> -->
                </p>
            </div>
            <div class="col-1 media_block">
                <!-- <img src="/newpion/static/pionfront/assets/img/vk.png">
                <img src="/newpion/static/pionfront/assets/img/fb.png"> -->
            </div>
        </div>

        <p class="underline">© АНО «Эволюция и Филантропия», {{now | date:"yyyy"}}. Все права защищены</p>
    </div>
</footer>